export default {
  notification: {
    title: 'Notification',
    description: 'You will receive a text message and email with a secure payment link once the pharmacy has reviewed your prescription',
    image: '/images/help/messages.png',
  },
  payment: {
    title: 'Payment',
    description: 'Once your prescription is paid for, we will process your order',
    image: '/images/help/wallet.png',
  },
  delivery: {
    title: 'Delivery',
    description: 'We will deliver your order to you within 2 hours for Greater London¹ & within 24 hours for the rest of mainland UK²',
    image: '/images/help/fox.png',
  },
  confirmation: {
    title: 'Confirmation',
    description: 'You will receive a 4-digit delivery confirmation code via text – you will be asked for this upon delivery',
    image: '/images/help/secret.png',
  },
};
